import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { filterDOMProps as $eUtJD$filterDOMProps, mergeProps as $eUtJD$mergeProps } from "@react-aria/utils";
import { ListKeyboardDelegate as $eUtJD$ListKeyboardDelegate } from "@react-aria/selection";
import { useState as $eUtJD$useState, useRef as $eUtJD$useRef, useEffect as $eUtJD$useEffect } from "react";
import { useField as $eUtJD$useField } from "@react-aria/label";
import { useFocusWithin as $eUtJD$useFocusWithin } from "@react-aria/interactions";
import { useGridList as $eUtJD$useGridList } from "@react-aria/gridlist";
import { useLocale as $eUtJD$useLocale } from "@react-aria/i18n";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $d7323bca8d074eeb$export$653eddfc964b0f8a = new WeakMap();
function $d7323bca8d074eeb$export$4f8b5cda58b7e8ff(props, state, ref) {
  var _ref = (0, $eUtJD$useLocale)(),
    direction = _ref.direction;
  var keyboardDelegate = props.keyboardDelegate || new (0, $eUtJD$ListKeyboardDelegate)({
    collection: state.collection,
    ref: ref,
    orientation: 'horizontal',
    direction: direction,
    disabledKeys: state.disabledKeys,
    disabledBehavior: state.selectionManager.disabledBehavior
  });
  var _ref2 = (0, $eUtJD$useField)(_objectSpread({}, props, {
      labelElementType: 'span'
    })),
    labelProps = _ref2.labelProps,
    fieldProps = _ref2.fieldProps,
    descriptionProps = _ref2.descriptionProps,
    errorMessageProps = _ref2.errorMessageProps;
  var _ref3 = (0, $eUtJD$useGridList)(_objectSpread({}, props, fieldProps, {
      keyboardDelegate: keyboardDelegate,
      shouldFocusWrap: true,
      linkBehavior: 'override'
    }), state, ref),
    gridProps = _ref3.gridProps;
  var _ref4 = (0, $eUtJD$useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    isFocusWithin = _ref5[0],
    setFocusWithin = _ref5[1];
  var _ref6 = (0, $eUtJD$useFocusWithin)({
      onFocusWithinChange: setFocusWithin
    }),
    focusWithinProps = _ref6.focusWithinProps;
  var domProps = (0, $eUtJD$filterDOMProps)(props);
  // If the last tag is removed, focus the container.
  var prevCount = (0, $eUtJD$useRef)(state.collection.size);
  (0, $eUtJD$useEffect)(function () {
    if (ref.current && prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
    prevCount.current = state.collection.size;
  }, [state.collection.size, isFocusWithin, ref]);
  $d7323bca8d074eeb$export$653eddfc964b0f8a.set(state, {
    onRemove: props.onRemove
  });
  return {
    gridProps: (0, $eUtJD$mergeProps)(gridProps, domProps, _objectSpread({
      role: state.collection.size ? 'grid' : null,
      'aria-atomic': false,
      'aria-relevant': 'additions',
      'aria-live': isFocusWithin ? 'polite' : 'off'
    }, focusWithinProps, fieldProps)),
    labelProps: labelProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  };
}
export { $d7323bca8d074eeb$export$653eddfc964b0f8a as hookData, $d7323bca8d074eeb$export$4f8b5cda58b7e8ff as useTagGroup };